import EnterpriseNavigation from './EnterpriseNavigation.component';

export default EnterpriseNavigation;